const MAP_INITIAL_OPTIONS = {
  zoomControl: true,           // Remove controles de zoom
  fullscreenControl: true,     // Remove botão de tela cheia
  streetViewControl: true,     // Remove Street View
  mapTypeControl: false,        // Remove seletor de tipo de mapa
  disableDefaultUI: true,       // Remove toda interface padrão
  keyboardShortcuts: false,     // Remove atalhos de teclado
  clickableIcons: false,        // Remove clique em ícones de estabelecimentos
  gestureHandling: 'greedy' as const, // Permite zoom sem precisar Ctrl
};

/**
 * Configurações visuais e comportamentais do Google Maps
 * Centraliza todas as configurações para facilitar manutenção
 */
export const MAP_CONFIG = {
  // Configurações padrão do mapa
  DEFAULT_ZOOM: 19,
  DEFAULT_CENTER: { lat: 0, lng: 0 },

  // Opções de aparência e comportamento do mapa
  MAP_OPTIONS: {
    simple: MAP_INITIAL_OPTIONS,
    allDisabled: {
      ...MAP_INITIAL_OPTIONS,
      zoomControl: false,           // Remove controles de zoom
      fullscreenControl: false,     // Remove botão de tela cheia
      streetViewControl: false,     // Remove Street View
      // Adiciona apenas as configurações únicas para mapa estático
      disableDoubleClickZoom: true,
      draggable: false,
      scrollwheel: false,
      gestureHandling: 'none'
    }
  },

  // IDs dos marcadores especiais
  MARKER_IDS: {
    INITIAL: 'initial-location',
    CLICKED: 'clicked-location'
  },

  // Títulos dos marcadores
  MARKER_TITLES: {
    INITIAL: 'Posição Inicial',
    CLICKED: 'Local clicado'
  }
} as const;

